// extracted by mini-css-extract-plugin
module.exports = {"button__red":"Button--button__red--30wnj","responsive":"Button--responsive--2_wZW","button__yellow":"Button--button__yellow--2AJ0q"};